export const ONBOARDING_DOMAIN = 'onboarding';
export const ONBOARDING_DOMAIN_URL = `/${ONBOARDING_DOMAIN}/*`;

export const ONBOARDING_PATHS = {
  messaging: '/messaging',
  createAccountAndContact: '/create-account-and-contact',
  fileIntelligence: '/file-intelligence',
  firmDetails: '/firm-details',
};

export const ONBOARDING_PAGE_TITLES = {
  messaging: 'Messaging - Onboarding',
  createAccountAndContact: 'Create Account and Contact - Onboarding',
  fileIntelligence: 'File Intelligence - Onboarding',
  firmDetails: 'Firm Details - Onboarding',
};

